import { Link } from "react-router-dom";

export default function HeroSection() {
  return (
    <section className="relative isolate overflow-hidden bg-gradient-to-br from-blue-950 via-blue-900 to-slate-900 px-4 py-14 text-white sm:px-6 sm:py-20 lg:py-24">
      <div
        aria-hidden="true"
        className="absolute -right-24 -top-32 -z-10 h-96 w-96 rounded-full bg-amber-400/15 blur-3xl"
      />
      <div
        aria-hidden="true"
        className="absolute -bottom-48 -left-20 -z-10 h-96 w-96 rounded-full bg-sky-300/15 blur-3xl"
      />
      <div className="mx-auto max-w-4xl text-center">
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://chat.whatsapp.com/GWARqQaw5B883UGZsCz08t"
          className="inline-flex rounded-full border border-white/20 bg-white/10 px-4 py-2 text-sm leading-6 text-blue-50 transition hover:bg-white/15"
        >
          Follow our travel updates
          <span className="ml-2 font-semibold text-amber-200">Join us →</span>
        </a>
        <p className="mt-8 text-xs font-bold uppercase tracking-[0.2em] text-sky-200 sm:text-sm">
          Take the scenic route with SKAdventures
        </p>
        <h1 className="mx-auto mt-3 max-w-3xl text-balance text-4xl font-bold tracking-tight text-white sm:text-5xl lg:text-6xl">
          Travelling is an investment in yourself.
        </h1>
        <p className="mx-auto mt-5 max-w-2xl text-base leading-7 text-blue-50/90 sm:text-lg sm:leading-8">
          Find inspiring places, enjoy experiences made for your kind of
          getaway, and create memories worth taking home. Your next adventure
          starts with SKAdventures.
        </p>
        <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
          <Link
            to="/camping"
            className="rounded-full bg-sky-300 px-6 py-3 text-sm font-bold text-blue-950 shadow-sm transition hover:bg-sky-200 sm:text-base"
          >
            Explore camping
          </Link>
          <Link
            to="/SahyadriTreks"
            className="rounded-full border border-white/35 bg-white/10 px-6 py-3 text-sm font-semibold text-white transition hover:bg-white/20 sm:text-base"
          >
            Discover treks
          </Link>
        </div>
      </div>
    </section>
  );
}
